import styled from "styled-components";

export default styled.span`
  font-weight: 400;
  font-size: 18px;
  color: #47464e;
`;
